export * from './lib/dgi-data-access.module';
export * as DGIActions from './lib/+state/dgi.actions';
export * as DGISelectors from './lib/+state/dgi.selectors';